import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";
import { RxDotFilled } from "react-icons/rx";
import ArabicComponent from "./../../../../../utils/ArabComponent/ArabicComponent";

import headerImage from "./assets/header.jpg";
import footerImage from "./assets/footer.jpg";
import axios from "axios";

import { color, table1 } from "./styles/pdf2Style";
import PageLayout from "./contractService/PageLayout";
import nodeinstance from "../../../../../nodeInstance";

export function addSpaceAfterLetter(word, index = 6) {
  if (word.length > 7) {
    // Check if the word is long enough to add a space
    return word.slice(0, index) + " " + word.slice(index); // Add a space after the 6th letter
  } else {
    return word; // If the word is 7 characters or shorter, return it as is
  }
}

export default function CostPlusContract({
  contractDetails,
  combinedData,
  generatedTitles,
}) {
  console.log(contractDetails, "contractDetails pdf");
  const companyDetails = contractDetails?.visa_provider;
  const clientDetails = contractDetails?.client;
  Font.register({
    family: "Arabic",
    src: ArabicRegular,
  });
  Font.register({
    family: "ArabicBold",
    src: ArabicBold,
  });
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      paddingHorizontal: 20,
      // paddingVertical: 30,
      fontSize: 9,
      paddingBottom: 100,
    },
  });

  const currentDate = new Date();

  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1
  const year = currentDate.getFullYear();

  const BASIC_INFO =
    contractDetails?.contract_cost_sheet_profession_basic_information;
  const CONTRACT_HEADINGS = contractDetails?.contract_cost_sheet_headings;
  const CONTRACT_COST_DETAILS =
    contractDetails?.contract_cost_sheet_cost_details;

  const jobPositions = contractDetails?.job_possition;
  const visaProfessions = contractDetails?.visa_profession;
  const professionalLevels = contractDetails?.profession_level;
  const nationaity = contractDetails?.nationality;

  const Table1Row = [];

  const Table1Col = [
    {
      col: "Actual Profession",
      title: "actual_profession",
    },
    {
      col: "Visa Profession",
      title: "visa_profession",
    },
    {
      col: "Profession Level",
      title: "profession_level",
    },
    {
      col: "Gender",
      title: "gender",
    },
    {
      col: "Nationality",
      title: "nationality",
    },
    {
      col: "Quantity",
      title: "quantity",
    },
    {
      col: "Salary",
      title: "Salary",
    },
    {
      col: "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
      title:
        "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
    },
    {
      col: "Total Monthly Charges (SAR)",
      title: "total_monthly_charges",
    },
  ];

  for (let i = 0; i < BASIC_INFO.length; i++) {
    let item = {
      contract_cost_sheet_profession_basic_information_id: BASIC_INFO[i].id,
      contract_id: BASIC_INFO[i]?.contract_id,
      actual_profession: jobPositions.find(
        (data) => data.id == BASIC_INFO[i]?.job_position_id
      )?.name,
      visa_profession: visaProfessions.find(
        (data) => data.id == BASIC_INFO[i]?.visa_profession_id
      )?.name,
      profession_level: professionalLevels.find(
        (data) => data.id == BASIC_INFO[i]?.profession_level_id
      )?.name,
      gender: BASIC_INFO[i]?.gender,
      nationality: nationaity.find(
        (data) => data.id == BASIC_INFO[i]?.nationality_id
      )?.name,
      quantity: BASIC_INFO[i]?.quantity,
      total_monthly_charges: 0,
    };
    for (let currentHeading of CONTRACT_HEADINGS) {
      const itemName =
        currentHeading?.rate_category_item_name ||
        currentHeading?.rate_category_item?.name;

      item[itemName] = CONTRACT_COST_DETAILS.find(
        (detail) =>
          detail?.contract_cost_sheet_heading_id == currentHeading?.id &&
          detail?.contract_cost_sheet_profession_basic_information_id ==
            BASIC_INFO[i].id
      )?.cost;
    }
    Table1Row.push(item);
  }

  for (let table1RowItem of Table1Row) {
    for (let currentHeading of CONTRACT_HEADINGS) {
      const itemName =
        currentHeading?.rate_category_item_name ||
        currentHeading?.rate_category_item?.name;
      if (itemName == "Salary") {
        table1RowItem.total_monthly_charges += Number(
          (Number(table1RowItem[itemName]) * 2) / 100
        ).toFixed(2);
        table1RowItem.total_monthly_charges += Number(
          table1RowItem[itemName]
        ).toFixed(2);
      } else {
        table1RowItem.total_monthly_charges += Number(
          table1RowItem[itemName]
        ).toFixed(2);
      }
    }
  }

  const TableTwoData = [
    {
      text: `* Valid only for ${year} (in future, rates shall be changed with respect to changes in KSA Govt. charges, if any).  The charges provided above are subject to change as per further amendments in current laws or new laws introduced by KSA government, changes in Nitaqat percentage slabs, changes in taxes that affect our cost (for example work permit, VAT, Saudi salary etc.) shall be applied & charged to Second PARTY at actuals.`,
    },
    {
      text: `**GoSI will be charged monthly in addition (GoSI is 2% on Basic+HRA, if there is no HRA, it considers 17% of Basic as HRA).`,
    },
    {
      text: `**Any incentive/OT will be charged & paid as advised by Second Party.`,
    },
  ];

  const TableTwoArabicData = [
    {
      text: `* صالحة فقط ${year} (في المستقبل ، سيتم تغيير الأسعار وفقًا للتغييرات في رسوم الحكومة السعودية ، إن وجدت). تخضع الرسوم المذكورة أعلاه للتغيير وفقًا للتعديلات الإضافية في القوانين الحالية أو القوانين الجديدة التي أدخلتها حكومة المملكة العربية السعودية ، والتغييرات في ألواح نطاق النسبة المئوية ، والتغييرات في الضرائب التي تؤثر على التكلفة (مثل تصريح العمل ، وضريبة القيمة المضافة ، والراتب السعودي ، وما إلى ذلك). يتم تطبيقها وتحميلها على الطرف الثاني بالقيم الفعلية.`,
    },
    {
      text: `** بالإضافة إلى ذلك سيتم فرض رسوم  شهرية لمؤسسة التامينات الإجتماعية  (هي 2٪ على الأساسي + بدل الإيجار، إذا لم يكن هناك ، فإنها تحتسب 17٪ من الأساسي).`,
    },
    {
      text: `** سيتم فرض ودفع أي حافز / الوقت الإضافي وفقًا لما ينصح به الطرف الثاني.`,
    },
  ];

  const Table3Data = [
    {
      text: `Contracts Period Between: ${
        contractDetails?.contract?.start_date || ""
      } and ${contractDetails?.contract?.end_date || ""}`,
      sub: [],
    },
    {
      text: `Contract Renewal: Upon completion of contract, the contract automatically renews for same period of time (i.e. ${
        contractDetails?.contract?.tenure || ""
      } months).`,
      sub: [],
    },
    {
      text: `Notice period to terminate the Contract: To terminate the contract, either party need to issue a notice to the other party, 60 days prior to Contract Expiry date.`,
      sub: [],
    },
    {
      text: `Refundable Security Deposit Payment: FIRST PARTY shall invoice SECOND PARTY, Two months full-monthly charge against Security Deposit.  This will be as Security Deposit, to use in worst case scenarios to pay-off the employee benefits/to cover damages.  This Refundable Deposit Payment will be returned on completion of the Contract OR adjusted against the last 2 Invoices.  The First security deposit invoice will be based on initial requirement quantities, for any additional requirements, separate invoices will be raised accordingly.`,
      sub: [],
    },
    {
      text: `Initial Invoice:`,
      sub: [
        "Security Deposit – Two (2) month full-monthly charge (Salary and service fee).",
        "Invoice payment should be made within 10 days after sign & submission of the contract.",
      ],
    },
    {
      text: `Employee Selection: Local-inside KSA / Overseas – sourcing can be assist by First Party & selection by SECOND PARTY.`,
      sub: [],
    },
    {
      text: `Replacement of Personnel: The Employee will initially be on a probationary period of three (03) months.  Should the Second Party decide to terminate an employee within the probation period, because the employee’s performance is not considered satisfactory or he is physically unfit or not willing to work, the First Party upon notification of the Second Party shall replace the employee accordingly. If the Employee completes his probation period and the Second Party Terminates the employee for a valid reason, the Second Party shall pay the Iqama, work permit and Government costs to the First Party on pro-rata. The Second Party shall provide minimum two warning letters with intimation to the First Party and only then terminate the employee. This clause is only for candidates selected under the Guarantee of the First Party.`,
      sub: [],
    },
    {
      text: `If any candidate is selected/ referred by Second Party or recruited through a third-party agency, the recruitment cost will remain same as that of Sourced candidates. The processing fees should be paid by the candidate. If the candidate is not ready to pay, the same shall be borne by Second Party. First Party   will not be responsible for any replacement against referred or third party sourced candidates. If candidate refuses to work, Resigns, is terminated or absconds or goes back to their home country, Second Party will be liable to pay the balance government cost on prorata + 2 Months Admin & Service charges of the First Party towards the respective employee.  `,
      sub: [],
    },
    {
      text: `Accommodation: shall provide by SECOND PARTY.`,
      sub: [],
    },
    {
      text: `Transportation: shall provide by SECOND PARTY. `,
      sub: [],
    },
    {
      text: `The monthly service charges include Visa, Work Permit, Iqama fee, Medical for iqama, Health Insurance, Salary, GoSI, Nitaqat, Ajeer, ATM Card, Vacation Pay, Vacation air-ticket, Exit re-entry fee, admin charges and End of Service Benefits (EoSB).`,
      sub: [],
    },
    {
      text: `The employee salary and First Party monthly service charge will start from the date of arrival of the Employee. Any delay in opening of the Projects or outlets of the Second Party should not affect the salary of the employees and First Party   service charges.`,
      sub: [],
    },
    {
      text: `Other costs by SECOND Party:`,
      sub: [
        "Recruitment Agency (of sourcing country) Service Charges: Recruitment agency charges, visa stamping charges shall borne by SECOND PARTY & pay directly to the Agency.",
        "Quarantine (Hotel, Taxi, medical) & other miscellaneous charges – First Party can assist in organizing the services & the charges shall be borne by Second Party.",
        "Joining Air Ticket: shall borne by Second party or by the Employee.",
        "Airport Pick-up / Drop: shall arrange by SECOND PARTY.",
        "Violations & Processing charges: if any violations exists, actual costs will be invoiced and shall borne by SECOND Party (one-time).",
        "Baladiya: shall arrange by SECOND PARTY at its cost.",
        "Final Exit visa: FIRST PARTY shall provide up on SECOND PARTY approval only.  If any employee is found threat to the First Party reputation, First Party can issue Final Exit directly and shall inform SECOND Party on the scenario.",
      ],
    },
    {
      text: `Monthly salary invoicing & payment time-line:`,
      sub: [
        "Timesheet submission (by Second Party): 21st to 22nd of the month.",
        "Invoice Submission (by First Party): 22nd of the month.",
        "Invoice Payment (by Second Party): 23rd to 25th of the month.",
        "Salary Payment (by First Party): 1st to 5th of the next month.",
      ],
    },
    {
      text: `Pre-mature Termination Penalties: if SECOND Party terminates FIRST Party or its’ any employee services during the contract, SECOND Party shall bear the below costs:`,
      sub: [
        "50% of FIRST Party Service Fee for the remaining contract period.",
        "Return air ticket for the Employee.",
        "This applies even if the candidate went on Exit Re-Entry (approved by Second Party) and did not return.  And it is exempted for Employee Abscond/Run-away cases.",
      ],
    },
    {
      text: `SECOND PARTY can terminate the contract with FIRST PARTY, if FIRST PARTY`,
      sub: [
        "Stops/abandons SECOND PARTY operations without any intimation.",
        "Violate the conditions of the Agreement.",
        "Goes Bankrupt.",
        "However, SECOND PARTY has to provide a written notice to FIRST PARTY to rectify the issue providing with sufficient time line to do so (minimum 1 week to a month based on the case).",
      ],
    },
    {
      text: `FIRST Party can terminate the contract with SECOND Party, if SECOND Party delay in payments.  However, FIRST Party has to provide a written notice to SECOND Party to act on the same (minimum one week to 15 days).  In addition, the pre-mature termination charges will be applied & invoiced to SECOND Party.`,
      sub: [],
    },
    {
      text: `The employee salary and First Party monthly service charge will start from the date of arrival of the Employee. Any delay in opening of the Projects or outlets of the Second Party should not affect the salary of the employees and First Party   service charges.`,
      sub: [],
    },
    {
      text: `If any candidate is absent for one day, only one day deduction should be done from his Basic salary. Also this should not affect any Government cost of First party charges.
`,
      sub: [],
    },
    {
      text: `The First Party charges will start from the date of Kiwa Request sent for Local Transfer and for Overseas, from date of arrival in Saudi Arabia`,
      sub: [],
    },
    {
      text: `Absenteeism: If any candidate is absent due to health issues and has informed the superior or presented the Medical bill, his salary should not be deducted. The Second party shall pay the salary of this worker for that particular day/ days. If the candidate takes an unplanned leave without informing anyone, his/ her salary should be deducted as per number of days absent and not any additional days. In any case, the First Party’s monthly cost and Government costs should not be affected. This should be paid in full.`,
      sub: [],
    },
    {
      text: `If any candidate resigns due to issues in work, accommodation, ill treatment, or any issues which are not resolved by the Second Party, the Second Party will need to pay the respective Employees Government costs (on Prorata) and two months service charges of the First Party along with return ticket of the worker`,
      sub: [],
    },
    {
      text: `Workers leaves/ annual vacation amount and ticket will be provided to the worker by the First Party only on completion of the 1 years contract. If the Second Party is approving or has committed to the worker for any leaves before contract period, the First Party shall not pay any Vacation salary, ticket amount etc. All travel costs etc, should be managed by the Employee himself or the Second Party. During the leave period of the worker, the First Party shall invoice all the government charges included First Party Monthly charges except the candidate’s salary. `,
      sub: [],
    },
    {
      text: `If the candidate doesn’t come back from his home country or any country where the Second Party has sent the worker to (trainings, meetings etc), the Second party shall be liable to pay the monthly Government costs + Admin fee and Service charges of the Employee for the entire contract period. During the leave period of the worker, the First Party shall invoice all the government charges included First Party Monthly charges except the candidate’s salary`,
      sub: [],
    },
    {
      text: `If the Employee goes on Annual Vacation and doesn’t return back due to whatsoever reason, the Second Party shall pay the Government cost incurred for the worker on pro-rata basis along with 2 months Admin & Service charge of the First Party`,
      sub: [],
    },
    {
      text: `Abscond Report: As the employees working under SECOND Party supervision, upon abscond or run-away of any employee, SECOND Party has to inform FIRST Party to declare it to Ministry through online.`,
      sub: [],
    },
    {
      text: `Liability on Damages: FIRST Party or its employees will not be responsible for SECOND Party valuables / properties.  Any kind of illegal act such as Assault, theft, loss by any employee of FIRST Party, SECOND Party can take legal action against that individual (but not on the organization).`,
      sub: [],
    },
    {
      text: `First Party shall provide any supporting documents requested by Employee or by SECOND Party.  The corresponding charges such as Chamber of Commerce attestation and Ministry of Foreign Affairs attestation will be invoiced to SECOND Party.`,
      sub: [],
    },
  ];

  const Table3DataArabic = [
    {
      NormalText: `Contracts Period Between: ${
        contractDetails?.contract?.start_date || ""
      } and ${contractDetails?.contract?.end_date || ""}`,
      Normalsub: [],
      text: `1.مدة العقد : ${contractDetails?.contract?.start_date || ""} و ${
        contractDetails?.contract?.end_date || ""
      }`,
      sub: [],
    },
    {
      NormalText: `Contract Renewal: Upon completion of contract, the contract automatically renews for same period of time (i.e. ${
        contractDetails?.contract?.tenure || ""
      } months).`,
      Normalsub: [],
      text: `2. تجديد العقد: عند الانتهاء  يتم تجديد العقد تلقائيًا لنفس الفترة الزمنية ، (${
        contractDetails?.contract?.tenure || ""
      } شهر).`,
      sub: [],
    },
    {
      NormalText: `Notice period to terminate the Contract: To terminate the contract, either party need to issue a notice to the other party, 60 days prior to Contract Expiry date.`,
      Normalsub: [],
      text: `3.  فترة الإخطار لإنهاء العقد: ، يتعين على أي من الطرفين إصدار إخطار للطرف الآخر ، قبل (60) يومًا من تاريخ إنتهاء العقد.`,
      sub: [],
    },
    {
      NormalText: `Refundable Security Deposit Payment: FIRST PARTY shall invoice SECOND PARTY, Two months full-monthly charge against Security Deposit.  This will be as Security Deposit, to use in worst case scenarios to pay-off the employee benefits/to cover damages.  This Refundable Deposit Payment will be returned on completion of the Contract OR adjusted against the last 2 Invoices.  The First security deposit invoice will be based on initial requirement quantities, for any additional requirements, separate invoices will be raised accordingly.`,
      Normalsub: [],
      text: `4.  دفعة تأمين قابلة للاسترداد:
 يجب على الطرف الأول إرسال فاتورة للطرف الثاني ، رسوم شهرية كاملة مقابل وديعة الضمان. سيكون هذا بمثابة وديعة تأمين ، لاستخدامها في أسوأ السيناريوهات لسداد مزايا الموظفين / لتغطية الأضرار. سيتم إرجاع دفعة الوديعة القابلة للاسترداد هذه عند اكتمال العقد أو تعديلها مقابل آخر فاتورتين. ستعتمد فاتورة إيداع الضمان الأولى على كميات المتطلبات الأولية ، ولأي متطلبات إ`,
      sub: [],
    },
    {
      NormalText: `Initial Invoice:`,
      Normalsub: [
        "Security Deposit – Two (2) month full-monthly charge (Salary and service fee).",
        "Invoice payment should be made within 10 days after sign & submission of the contract.",
      ],
      text: `5. الفاتورة الأولية :`,
      sub: [
        "وديعة التأمين - رسوم شهرين (2) كاملة - شهريًا (إجمالي الراتب ورسوم الخدمة لكل عميل)",
        "يجب أن يتم سداد الفاتورة في غضون 10 أيام بعد توقيع العقد وتقديمه.",
      ],
    },
    {
      NormalText: `Employee Selection: Local-inside KSA / Overseas – sourcing can be assist by First Party & selection by SECOND PARTY.`,
      Normalsub: [],
      text: `6. اختيار الموظف: محلي - داخل المملكة العربية السعودية / في الخارج - إختيار من قبل الطرف الثاني.`,
      sub: [],
    },
    {
      NormalText: `Replacement of Personnel: The Employee will initially be on a probationary period of three (03) months.  Should the Second Party decide to terminate an employee within the probation period, because the employee’s performance is not considered satisfactory or he is physically unfit or not willing to work, the First Party upon notification of the Second Party shall replace the employee accordingly. If the Employee completes his probation period and the Second Party Terminates the employee for a valid reason, the Second Party shall pay the Iqama, work permit and Government costs to the First Party on pro-rata. The Second Party shall provide minimum two warning letters with intimation to the First Party and only then terminate the employee. This clause is only for candidates selected under the Guarantee of the First Party.`,
      Normalsub: [],
      text: `7. إستبدال الموظفين :سيكون الموظف في البداية في فترة إختبار مدتها (03) ثلاثة أشهر ، إذا قرر الطرف الثاني إنهاء خدمة الموظف خلال فترة الإختبار لأن اداء الموظف لا يعتبر مرضياً او انه غير لائق بدنياً او غير راغب في العمل ، يقوم الطرف الاول عند إخطار الطرف الثاني له بإستبدال الموظف وفقاً لذلك .إذا اكمل الموظف فترة الإختبار الخاصة به وقام الثاني بالإنهاء لسبب وجيه، يجب على الطرف الثاني دفع الإقامة وتصريح العمل والتكاليف الحكومية للطرف الأول على اساس نسبي ، يجب على الطرف الثاني تقديم رسالتين تحذيريتين كحد ادنى مع تنبيه للطرف الاول وبعد ذلك فقط ينهي الموظف . هذا البند مخصص فقط للمرشحين المختارين بموجب ضمان الطرف الاول .`,
      sub: [],
    },
    {
      NormalText: `If any candidate is selected/ referred by Second Party or recruited through a third-party agency, the recruitment cost will remain same as that of Sourced candidates. The processing fees should be paid by the candidate. If the candidate is not ready to pay, the same shall be borne by Second Party. First Party   will not be responsible for any replacement against referred or third party sourced candidates. If candidate refuses to work, Resigns, is terminated or absconds or goes back to their home country, Second Party will be liable to pay the balance government cost on prorata + 2 Months Admin & Service charges of the First Party towards the respective employee.  `,
      Normalsub: [],
      text: `8. إذا تم إختيار / إحالة اي مرشح من قبل طرف ثاني او تم نجنيده من خلال وكالة تابعة لجهة خارجية ، فستظل تكلفة التوظيف مماثلة  لتلك الخاصة بالمرشحين من مصادر ، يجب أن يدفع المرشح رسوم المعالجة . إذا لم يكن المرشح جاهزاً للدفع فيجب أن يتحمل الطرف الثاني المبلغ . لن يكون الطرف الاول مسؤولاً عن إستبدال اي من المرشحين المحالين من مصادر او من مصادر خارجية ، إذا رفض المرشح العمل او إستقال او تم إنهاء عمله او هرب او عاد إلى وطنه ، فسيكون الطرف الثاني مسؤولاص عن دفع رصيد التكلفة الحكومية بالتناسب + رسوم الإدارة والخدمة لمدة شهرين  للطرف الاول تجاه الموظف المعني . `,
      sub: [],
    },
    {
      NormalText: `Accommodation: shall provide by SECOND PARTY.`,
      Normalsub: [],
      text: `9. السكن يتم توفيره من قبل الطرف الثاني .`,
      sub: [],
    },
    {
      NormalText: `Transportation: shall provide by SECOND PARTY. `,
      Normalsub: [],
      text: `10. النقل يجب توفيره من قبل الطرف الثاني . `,
      sub: [],
    },
    {
      NormalText: `The monthly service charges include Visa, Work Permit, Iqama fee, Medical for iqama, Health Insurance, Salary, GoSI, Nitaqat, Ajeer, ATM Card, Vacation Pay, Vacation air-ticket, Exit re-entry fee, admin charges and End of Service Benefits (EoSB).`,
      Normalsub: [],
      text: `11. الدفعات الشهرية تشمل رسوم الخدمة الشهرية للتأشيرة ، وتصريح العمل ورسوم الإقامة ، والفحص الطبي للإقامة ، والفحص الطبي للإقامة ، التأمين ، الراتب ، التأمينات الإجتماعية ، نطاقات ، أجير ، بطاقة الصراف الآلي ، دفع الإجازات ، وتذكرة الإجازة ، رسوم الخروج والعودة ، الرسوم الإدارية ومزايا نهاية الخدمة .`,
      sub: [],
    },
    {
      NormalText: `The employee salary and First Party monthly service charge will start from the date of arrival of the Employee. Any delay in opening of the Projects or outlets of the Second Party should not affect the salary of the employees and First Party   service charges.`,
      Normalsub: [],
      text: `12. يبدأ راتب الموظف ورسوم الخدمة الشهرية للطرف الأول من تاريخ وصول الموظف. يجب ألا يؤثر أي تأخير في افتتاح مشاريع أو منافذ الطرف الثاني على رواتب الموظفين ورسوم خدمات الطرف الأول .`,
      sub: [],
    },
    {
      NormalText: `Other costs by SECOND Party:`,
      Normalsub: [
        "Recruitment Agency (of sourcing country) Service Charges: Recruitment agency charges, visa stamping charges shall borne by SECOND PARTY & pay directly to the Agency.",
        "Quarantine (Hotel, Taxi, medical) & other miscellaneous charges – First Party can assist in organizing the services & the charges shall be borne by Second Party.",
        "Joining Air Ticket: shall borne by Second party or by the Employee.",
        "Airport Pick-up / Drop: shall arrange by SECOND PARTY.",
        "Violations & Processing charges: if any violations exists, actual costs will be invoiced and shall borne by SECOND Party (one-time).",
        "Baladiya: shall arrange by SECOND PARTY at its cost.",
        "Final Exit visa: FIRST PARTY shall provide up on SECOND PARTY approval only.  If any employee is found threat to the First Party reputation, First Party can issue Final Exit directly and shall inform SECOND Party on the scenario.",
      ],
      text: `13. مصروفات أخرى على الطرف الثاني :`,
      sub: [
        "-  رسوم خدمة وكالة التوظيف (البلد المصدر): يتحمل الطرف الثاني رسوم وكالة التوظيف ورسوم ختم التأشيرة ويتم دفعها مباشرة إلى الوكالة .",
        "- الحجر الصحي (فندق ، سيارة أجرة ،الفحص الطبي) ورسوم متنوعة أخرى - يمكن للطرف الأول المساعدة في تنظيم الخدمات ويتحمل الطرف الثاني  الرسوم",
        "-  تذاكر الطيران يتحملها الطرف الثاني او الموظف . ",
        "- النقل من المطار: مسئوولية   الطرف الثاني .",
        `- رسوم الإنتهاكات والمعالجة: في حالة وجود أي إنتهاكات ، سيتم
     إصدار فاتورة بالتكاليف الفعلية ويتحملها الطرف الثاني (لمرة واحد) .`,
        "- البلدية: يتم الترتيب من قبل الطرف الثاني على نفقته .",
        "- تأشيرة الخروج النهائي: يجب على الطرف الأول تقديم موافقة الطرف الثاني فقط. إذا وجد أي موظف تهديدًا لسمعة الطرف الأول ، فيمكن للطرف الأول إصدار الخروج النهائي مباشرةً وإبلاغ الطرف الثاني بالسيناريو .",
      ],
    },
    {
      NormalText: `Monthly salary invoicing & payment time-line:`,
      Normalsub: [
        "Timesheet submission (by Second Party): 21st to 22nd of the month.",
        "Invoice Submission (by First Party): 22nd of the month.",
        "Invoice Payment (by Second Party): 23rd to 25th of the month.",
        "Salary Payment (by First Party): 1st to 5th of the next month.",
      ],
      text: `14. فواتير الراتب الشهرية والجدول الزمني للدفع :`,
      sub: [
        "- تقديم سجل الدوام (من قبل الطرف الثاني): من 21 إلى 22 من الشهر",
        "-  تقديم الفاتورة (من قبل الطرف الأول): يوم 22 من الشهر .",
        "- دفع الفاتورة إلى الطرف الثاني من تاريخ 23 – 25 في الشهر .",
        "- دفع الراتب (من قبل الطرف الأول) من تاريخ (01) الأول إلى الخامس (05) من الشهر التالي.",
      ],
    },
    {
      NormalText: `Pre-mature Termination Penalties: if SECOND Party terminates FIRST Party or its’ any employee services during the contract, SECOND Party shall bear the below costs:`,
      Normalsub: [
        "50% of FIRST Party Service Fee for the remaining contract period.",
        "Return air ticket for the Employee.",
        "This applies even if the candidate went on Exit Re-Entry (approved by Second Party) and did not return.  And it is exempted for Employee Abscond/Run-away cases.",
      ],
      text: `15.  عقوبات الإنهاء قبل إنتهاء مدة العقد :
إذا انهى الطرف الثاني الطرف الاول او اي من خدمات الموظفين الخاصين به أثناء العقد ، يتحمل الطرف الثاني التكاليف التالية :`,
      sub: [
        "- 50% من رسوم خدمة الطرف الأول للفترة المتبقية من العقد .",
        "-  تذكرة طيران العودة للموظف .",
        `- ينطبق هذا حتى إذا ذهب المرشح خروج وعودة ( وافق عليه 
    الطرف الثاني ) ولمد يعد وتستثنى  حالات  الغياب/ الهروب .`,
      ],
    },
    {
      NormalText: `SECOND PARTY can terminate the contract with FIRST PARTY, if FIRST PARTY`,
      Normalsub: [
        "Stops/abandons SECOND PARTY operations without any intimation.",
        "Violate the conditions of the Agreement.",
        "Goes Bankrupt.",
        "However, SECOND PARTY has to provide a written notice to FIRST PARTY to rectify the issue providing with sufficient time line to do so (minimum 1 week to a month based on the case).",
      ],
      text: `16. يمكن للطرف الثاني إنهاء العقد مع الطرف الأول ، إذا كان الطرف الأول :`,
      sub: [
        "- توقف / تخلى عن عمليات الطرف الثاني دون تنبيه .",
        "- مخالفة شروط الاتفاقية . ",
        "- اعلان الإفلاس .",
        "-  ومع ذلك يتعين على الطرف الثاني تقديم إخطار كتابي إلى الطرف الاول لتصحيح المشكلة  مع توفير جدول زمني كافٍ للقيام بذلك ( الحد الأدنى من أسبوع إلى شهر بناءً على الحالة ) ",
      ],
    },
    {
      NormalText: `FIRST Party can terminate the contract with SECOND Party, if SECOND Party delay in payments.  However, FIRST Party has to provide a written notice to SECOND Party to act on the same (minimum one week to 15 days).  In addition, the pre-mature termination charges will be applied & invoiced to SECOND Party.`,
      Normalsub: [],
      text: `17
. يمكن للطرف الأول إنهاء عقد الطرف الثاني إذا تأخر الطرف الأول في المدفوعات . ومع ذلك يتعين على الطرف الثاني تقديم إخطار  كتابي لتصحيح المشكلة مع جدول زمني كافٍ للقيام بذلك ( الحد الأدنى من أسبوع إلى شهر بناءً على الحالة ) . سيتم تطبيق رسوم الإنهاء  قبل النضج وإصدار فاتورة بها إلى الطرف الثاني .`,
      sub: [],
    },
    {
      NormalText: `The employee salary and First Party monthly service charge will start from the date of arrival of the Employee. Any delay in opening of the Projects or outlets of the Second Party should not affect the salary of the employees and First Party   service charges.`,
      Normalsub: [],
      text: `18. يبدأ راتب الموظف ورسوم الخدمة الشهرية للطرف الأول من تاريخ وصول الموظف. يجب ألا يؤثر أي تأخير في افتتاح مشاريع أو منافذ الطرف الثاني على رواتب الموظفين ورسوم خدمات الطرف الأول .`,
      sub: [],
    },
    {
      NormalText: `If any candidate is absent for one day, only one day deduction should be done from his Basic salary. Also this should not affect any Government cost of First party charges.
      `,
      Normalsub: [],
      text: `19. في حال تغيب أي مرشح ليوم واحد يتم خصم يوم واحد فقط من راتبه الأساسي. كما يجب ألا يؤثر ذلك على أي تكلفة حكومية لرسوم الطرف الأول.`,
      sub: [],
    },
    {
      NormalText: `The First Party charges will start from the date of Kiwa Request sent for Local Transfer and for Overseas, from date of arrival in Saudi Arabia`,
      Normalsub: [],
      text: `20. ستبدأ رسوم الطرف الأول من تاريخ إرسال طل (قوى) التحويل المحلي وللخارج ، من تاريخ الوصول إلى المملكة العربية السعودية.`,
      sub: [],
    },
    {
      NormalText: `Absenteeism: If any candidate is absent due to health issues and has informed the superior or presented the Medical bill, his salary should not be deducted. The Second party shall pay the salary of this worker for that particular day/ days. If the candidate takes an unplanned leave without informing anyone, his/ her salary should be deducted as per number of days absent and not any additional days. In any case, the First Party’s monthly cost and Government costs should not be affected. This should be paid in full.`,
      Normalsub: [],
      text: `21. التغيب عن العمل: إذا تغيب أي مرشح لأسباب صحية وأبلغ الرئيس او قدم الفاتورة الطبية ، فلا يجوز خصم راتبه. يلتزم الطرف الثاني بدفع أجر هذا العامل عن ذلك اليوم / الأيام المحددة. إذا أخذ المرشح إجازة غير مخطط لها دون إبلاغ أي شخص ، فيجب خصم راتبه / راتبها حسب عدد الأيام المتغيبة وليس أي أيام إضافية. في أي حال ، يجب ألا تتأثر التكلفة الشهرية للطرف الأول والتكاليف الحكومية. يجب دفع هذا بالكامل.`,
      sub: [],
    },
    {
      NormalText: `If any candidate resigns due to issues in work, accommodation, ill treatment, or any issues which are not resolved by the Second Party, the Second Party will need to pay the respective Employees Government costs (on Prorata) and two months service charges of the First Party along with return ticket of the worker`,
      Normalsub: [],
      text: `22. إذا استقال أي مرشح بسبب مشاكل في العمل ، أو الإقامة ، أو سوء المعاملة ، أو اي قضايا لم يتم حلها من قبل الطرف الثاني ، فسيحتاج الطرف الثاني إلى دفع التكاليف الحكومية للموظفين المعنيين (بالتناسب)  ورسوم خدمة شهرين من الطرف الأول مع تذكرة عودة العامل .`,
      sub: [],
    },
    {
      NormalText: `Workers leaves/ annual vacation amount and ticket will be provided to the worker by the First Party only on completion of the 1 years contract. If the Second Party is approving or has committed to the worker for any leaves before contract period, the First Party shall not pay any Vacation salary, ticket amount etc. All travel costs etc, should be managed by the Employee himself or the Second Party. During the leave period of the worker, the First Party shall invoice all the government charges included First Party Monthly charges except the candidate’s salary. `,
      Normalsub: [],
      text: `23.  إجازات العمل / سيتم تأمين قيمة الإجازة السنوية والتذكرة للعامل من قبل الطرف الأول فقط عند الانتهاء من عقد مدته سنة واحدة. إذا وافق الطرف الثاني على أي إجازات قبل فترة العقد أو التزم بها ، فلا يجوز للطرف الأول دفع أي راتب إجازة أو مبلغ التذكرة إلخ. يجب أن يدير الموظف نفسه أو الطرف الثاني جميع تكاليف السفر وما إلى ذلك. خلال فترة إجازة العامل ، يقوم الطرف الأول بفاتورة جميع الرسوم الحكومية بما في ذلك الرسوم الشهرية للطرف الأول باستثناء راتب المرشح .`,
      sub: [],
    },
    {
      NormalText: `If the candidate doesn’t come back from his home country or any country where the Second Party has sent the worker to (trainings, meetings etc), the Second party shall be liable to pay the monthly Government costs + Admin fee and Service charges of the Employee for the entire contract period. During the leave period of the worker, the First Party shall invoice all the government charges included First Party Monthly charges except the candidate’s salary`,
      Normalsub: [],
      text: `24. إذا لم يعد المرشح من وطنه أو أي بلد أرسل فيه الطرف الثاني العامل إلى (التدريبات والاجتماعات وما إلى ذلك) ، فسيكون الطرف الثاني مسؤولاً عن دفع التكاليف الحكومية الشهرية + الرسوم الإدارية ورسوم الخدمة الخاصة بـ الموظف طوال فترة العقد. خلال فترة إجازة العامل ، يقوم الطرف الأول بفاتورة جميع الرسوم الحكومية بما في ذلك الرسوم الشهرية للطرف الأول باستثناء راتب المرشح  .`,
      sub: [],
    },
    {
      NormalText: `If the Employee goes on Annual Vacation and doesn’t return back due to whatsoever reason, the Second Party shall pay the Government cost incurred for the worker on pro-rata basis along with 2 months Admin & Service charge of the First Party`,
      Normalsub: [],
      text: `25. إذا ذهب الموظف في إجازة سنوية ولم يعد مرة أخرى لإي سبب من الأسباب ، يتعين على الطرف الثاني دفع التكلفة الحكومية المتكبدة للعامل على أساس تناسبي إلى جانب رسوم الإدارة والخدمة لمدة شهرين للطرف الأول .`,
      sub: [],
    },
    {
      NormalText: `Abscond Report: As the employees working under SECOND Party supervision, upon abscond or run-away of any employee, SECOND Party has to inform FIRST Party to declare it to Ministry through online.`,
      Normalsub: [],
      text: `26. تقرير الغياب : نظرًا لأن الموظفين  يعملون تحت إشراف الطرف الثاني ، عند فرار أو هروب أي موظف ، يتعين على الطرف الثاني  إبلاغ  الطرف لالأول لإبلاغ ذلك للوزارة عبر الإنترنت .`,
      sub: [],
    },
    {
      NormalText: `Liability on Damages: FIRST Party or its employees will not be responsible for SECOND Party valuables / properties.  Any kind of illegal act such as Assault, theft, loss by any employee of FIRST Party, SECOND Party can take legal action against that individual (but not on the organization).`,
      Normalsub: [],
      text: `27. المسؤولية عن الأضرار: لن يكون الطرف الأول أو موظفيه مسؤولين عن ممتلكات  الطرف الثاني. يمكن لأي نوع من الأعمال غير القانونية ان تحدث مثل الاعتداء والسرقة والخسارة من قبل أي موظف من الطرف الاول ، يمكن للطرف الثاني اتخاذ إجراء قانوني ضد هذا الفرد (ولكن ليس على المنظمة).`,
      sub: [],
    },
    {
      NormalText: `First Party shall provide any supporting documents requested by Employee or by SECOND Party.  The corresponding charges such as Chamber of Commerce attestation and Ministry of Foreign Affairs attestation will be invoiced to SECOND Party.`,
      Normalsub: [],
      text: `28. يجب على الطرف الأول تقديم أي مستندات داعمة يطلبها الموظف أو الطرف الثاني. سيتم إرسال فاتورة بالرسوم المقابلة مثل شهادة غرفة التجارة وشهادة وزارة الخارجية إلى الطرف الثاني`,
      sub: [],
    },
  ];

  const firstParty = [
    {
      title: "OPERATIONS DEPARTMENT",
      name: companyDetails?.authorized_project_representative_name,
      designation:
        companyDetails?.authorized_project_representative_designation,
      signature: " ",
    },
    {
      title: "FINANCE DEPARTMENT",
      name: companyDetails?.authorized_accounts_representative_name,
      designation:
        companyDetails?.authorized_accounts_representative_designation,
      signature: " ",
    },
    {
      title: "APPROVED BY",
      name: companyDetails?.authorized_person_name,
      designation: companyDetails?.authorized_person_designation,
      signature: " ",
    },
  ];
  const secondParty = [
    {
      title: "OPERATIONS / HR DEPARTMENT",
      name: clientDetails?.authorized_project_representative_name,
      designation: clientDetails?.authorized_project_representative_designation,
      signature: " ",
    },
    {
      title: "FINANCE / HR DEPARTMENT",
      name: clientDetails?.authorized_accounts_representative_name,
      designation:
        clientDetails?.authorized_accounts_representative_designation,
      signature: " ",
    },
    {
      title: "APPROVED BY",
      name: clientDetails?.authorized_person_name,
      designation: clientDetails?.authorized_person_designation,
      signature: " ",
    },
  ];

  const feesPayableBySecondParty = [];

  const CONTRACT_FEE_PAYABLE = contractDetails?.contract_fees_payables;

  for (let fee of CONTRACT_FEE_PAYABLE) {
    feesPayableBySecondParty.push({
      name: fee?.item,
      cost: fee?.cost,
      remarks: fee?.remark,
    });
  }

  function returnSrc(path = "") {
    return {
      uri: path,
      method: "GET",
      body: "",
      headers: { "Cache-Control": "no-cache" },
    };
  }

  if (generatedTitles?.length > 0) {
    generatedTitles = [{ col: "S.NO", title: "S.NO" }, ...generatedTitles];
    generatedTitles = generatedTitles?.filter(
      (titles) => titles.col !== "TOTAL MONTHLY CHARGES (SAR)"
    );
    generatedTitles = [
      ...generatedTitles,
      {
        col: "TOTAL MONTHLY CHARGES (SAR)",
        title: "TOTAL MONTHLY CHARGES (SAR)",
      },
    ];
  }

  const T1ColumnWidths = new Array(Number(generatedTitles.length + 1)).fill(
    95 / Number(generatedTitles.length - 1)
  );
  T1ColumnWidths[0] = 5;
  console.log("companyDetails.........companyDetails", companyDetails);
  const token = localStorage.getItem("nodeToken");

  return (
    <Document>
      {/* <Page size="A4" style={styles.page}> */}
      <PageLayout pageNo={1} company={companyDetails}>
        {/* <Image
          style={{ marginBottom: 20 }}
          fixed
          src={
            companyDetails?.header && companyDetails?.header != ""
              ? returnSrc(companyDetails?.header)
              : headerImage
          }
        /> */}
        <Text
          style={{
            textAlign: "center",
            marginTop: 10,
            fontSize: 12,
            fontFamily: "Helvetica-Bold",
          }}
        >
          ANNEXURE – I
        </Text>
        <Text
          style={{
            textAlign: "center",
            fontSize: 9,
          }}
        >
          (COMMERCIAL AND OTHER TERMS ACCEPTED AND SIGNED BY BOTH PARTIES)
        </Text>

        <View style={{ marginTop: 20, gap: 10 }}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={{ fontFamily: "Helvetica-Bold" }}> First Party: </Text>
            <Text style={{ fontFamily: "ArabicBold" }}>
              الطرف الأول <Text>:</Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <View style={{ gap: 4, marginLeft: 10, width: "50%" }}>
              <Text>{companyDetails?.name}</Text>
              <Text>{companyDetails?.company_registration}</Text>
              <Text>{companyDetails?.address}</Text>
              <Text>{companyDetails?.po_box}</Text>
              <Text>{companyDetails?.pincode}</Text>
            </View>
            <View
              style={{
                gap: 4,
                display: "flex",
                alignItems: "flex-end",
                width: "50%",
              }}
            >
              <Text style={{ fontFamily: "Arabic" }}>
                {companyDetails?.name_arabic}
              </Text>

              <Text>{companyDetails?.company_registration}</Text>

              <Text style={{ fontFamily: "Arabic" }}>
                {companyDetails?.address_arabic}
              </Text>

              <Text>{companyDetails?.po_box}</Text>

              <Text>{companyDetails?.pincode}</Text>
            </View>
          </View>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={{ fontFamily: "Helvetica-Bold" }}>
              {" "}
              Second Party:{" "}
            </Text>
            <Text style={{ fontFamily: "ArabicBold" }}>
              الطرف الثاني <Text>:</Text>
            </Text>
          </View>

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <View style={{ gap: 4, marginLeft: 10, width: "50%" }}>
              <Text>{clientDetails?.name}</Text>
              <Text>{clientDetails?.company_registration}</Text>
              <Text>{clientDetails?.address}</Text>
              <Text>{clientDetails?.po_box}</Text>
              <Text>{clientDetails?.pincode}</Text>
            </View>
            <View
              style={{
                gap: 4,
                display: "flex",
                alignItems: "flex-end",
                width: "50%",
              }}
            >
              <Text style={{ fontFamily: "Arabic" }}>
                {clientDetails?.name}
              </Text>

              <Text style={{ fontFamily: "Arabic" }}>
                {clientDetails?.company_registration}
              </Text>

              <Text style={{ fontFamily: "Arabic" }}>
                {clientDetails?.address}
              </Text>

              <Text style={{ fontFamily: "Arabic" }}>
                {clientDetails?.po_box}
              </Text>

              <Text style={{ fontFamily: "Arabic" }}>
                {clientDetails?.pincode}
              </Text>
            </View>
          </View>
        </View>
        <Text
          style={{
            marginTop: 15,
            fontFamily: "Helvetica-Bold",
          }}
        >
          l. MONTHLY CHARGES:
        </Text>

        {/* table */}
        <View>
          <View
            style={[table1.table, color.bgGray, styles.bold, { borderLeft: 1 }]}
          >
            {generatedTitles?.length > 0 &&
              generatedTitles?.map((heading, i) => {
                return (
                  <View
                    key={heading.title}
                    style={[
                      table1.cell,
                      {
                        // width:  `${ i==0   ? '5%' : 95/(t1Headers?.length-1)+'%' }`
                        width: T1ColumnWidths[i] + "%",
                      },
                    ]}
                  >
                    <Text style={[styles.wrap, styles.textCenter]} break>
                      {heading?.col?.toUpperCase()}
                    </Text>
                  </View>
                );
              })}
          </View>
          <View>
            {combinedData?.map((data, i) => {
              return (
                <View style={[table1.table, { borderLeft: 1 }]} key={i}>
                  <View
                    key={0}
                    style={[table1.cell, { width: T1ColumnWidths[0] + "%" }]}
                  >
                    <Text style={[styles.wrap, styles.textCenter]} break>
                      {i + 1}
                    </Text>
                  </View>
                  {generatedTitles.length > 0 &&
                    generatedTitles?.map((header, headerIndex) => {
                      if (headerIndex > 0) {
                        return (
                          <React.Fragment key={header.col}>
                            {header?.basic ||
                            header.col ===
                              "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)" ? (
                              <View
                                style={[
                                  table1.cell,
                                  {
                                    width:
                                      T1ColumnWidths[headerIndex + 1] + "%",
                                  },
                                ]}
                              >
                                <Text
                                  style={[styles.wrap, styles.textCenter]}
                                  break
                                >
                                  {addSpaceAfterLetter(
                                    String(data[header?.title]),
                                    6
                                  )}
                                </Text>
                              </View>
                            ) : (
                              <View
                                style={[
                                  table1.cell,
                                  {
                                    width:
                                      T1ColumnWidths[headerIndex + 1] + "%",
                                  },
                                ]}
                              >
                                <Text
                                  style={[styles.wrap, styles.textCenter]}
                                  break
                                >
                                  {
                                    data?.data?.find(
                                      (item) => item.heading === header?.title
                                    )?.cost
                                  }
                                </Text>
                              </View>
                            )}
                          </React.Fragment>
                        );
                      } else return null;
                    })}
                </View>
              );
            })}
          </View>
        </View>
        {/* note */}
        <Text
          style={{
            fontSize: 12,
            marginVertical: 20,
          }}
        >
          All of the above charges are excluding 15% VAT. 15% VAT will be
          applicable and added to all invoices, Governmental and
          Non-Governmental
        </Text>
        {/* special table costplus */}
        <Text
          style={{
            marginVertical: 10,
            fontFamily: "Helvetica-Bold",
          }}
        >
          ll. FEES PAYABLE BY SECOND PARTY:
        </Text>
        <View style={{ borderBottom: 1, marginTop: 0, textAlign: "center" }}>
          {/* row 1 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
              backgroundColor: "black",
              color: "white",
            }}
          >
            <View style={{ width: "10%", borderRight: 1, padding: 2 }}>
              <Text break>Sl.NO</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>ITEMS</Text>
            </View>
            <View style={{ width: "30%", padding: 2, borderRight: 1 }}>
              <Text break>COST</Text>
            </View>
            <View style={{ width: "30%", padding: 2 }}>
              <Text break>REMARKS</Text>
            </View>
          </View>
          {feesPayableBySecondParty?.map((item, index) => (
            <View
              key={index}
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "10%", borderRight: 1, padding: 2 }}>
                <Text break>{index + 1}</Text>
              </View>
              <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
                <Text break>{item.name}</Text>
              </View>
              <View style={{ width: "30%", padding: 2, borderRight: 1 }}>
                <Text break>{item.cost}</Text>
              </View>
              <View style={{ width: "30%", padding: 2 }}>
                <Text break>{item.remarks}</Text>
              </View>
            </View>
          ))}
        </View>

        {/* Table 2 */}
        <View style={{ flexDirection: "row", border: 1, marginTop: 40 }}>
          {/* col 1 */}
          <View style={{ borderRight: 1, width: "100%", padding: 5 }}>
            {TableTwoData?.map((item, index) => (
              <View style={{ marginVertical: 10 }} key={index}>
                <Text break style={{ lineHeight: 1.5, fontSize: 9 }}>
                  {item?.text}
                </Text>
              </View>
            ))}
          </View>
          {/* col 2 */}
          <View style={{ width: "100%", padding: 5 }}>
            {TableTwoArabicData?.map((item, index) => (
              <View style={{ marginVertical: 10 }} key={index}>
                <ArabicComponent arabText={item?.text} textBreak />
              </View>
            ))}
          </View>
        </View>
        {/* <Image
          style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}
          fixed
          src={
            companyDetails?.footer && companyDetails?.footer != ""
              ? returnSrc(companyDetails?.footer)
              : footerImage
          }
        /> */}
      </PageLayout>
      <PageLayout pageNo={1} company={companyDetails}>
        {/* <Image
          style={{ marginBottom: 20 }}
          fixed
          src={
            companyDetails?.header && companyDetails?.header != ""
              ? returnSrc(companyDetails?.header)
              : headerImage
          }
        /> */}
        <Text
          style={{
            marginTop: 15,
            fontFamily: "Helvetica-Bold",
            marginBottom: 20,
          }}
        >
          lll. TERMS:{" "}
          <Text style={{ fontFamily: "ArabicBold" }}> الفقرة الثانية:</Text>
        </Text>
        {/* table 3 */}
        <View
          style={{ width: "100%", height: 1, borderBottom: 1 }}
          fixed
        ></View>
        {Table3DataArabic?.map((data, index) => (
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
            key={index}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
              <Text break>{index + 1}</Text>
            </View>
            {/* <View style={{ width: "45%", borderRight: 1, padding: 10 }}>
              <Text break>{data.NormalText}</Text>
            </View> */}
            <View style={{ width: "45%", borderRight: 1, padding: 10 }}>
              <Text break>{data.NormalText}</Text>
              {data.Normalsub.map((subItem, subIndex) => (
                <Text key={subIndex} break>
                  . {subItem}
                </Text>
              ))}
            </View>
            {/* <View style={{ width: "45%", padding: 10 }}>
              <ArabicComponent arabText={data.text} textBreak />
            </View> */}
            <View style={{ width: "45%",padding: 5}}>
              <ArabicComponent arabText={data.text} textBreak />
              {data.sub.map((subItem, subIndex) => (
                <ArabicComponent key={subIndex} arabText={subItem} textBreak />
              ))}
            </View>
          </View>
        ))}

        <View style={{ width: "100%", height: 1, borderTop: 1 }} fixed></View>
        {/* <Image
          style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}
          fixed
          src={
            companyDetails?.footer && companyDetails?.footer != ""
              ? returnSrc(companyDetails?.footer)
              : footerImage
          }
        /> */}
      </PageLayout>
      <PageLayout pageNo={1} company={companyDetails}>
        {/* <Image
          style={{ marginBottom: 20 }}
          fixed
          src={
            companyDetails?.header && companyDetails?.header != ""
              ? returnSrc(companyDetails?.header)
              : headerImage
          }
        /> */}
        {/* table 4 */}
        <Text
          style={{
            marginTop: 15,
            fontFamily: "Helvetica-Bold",
          }}
        >
          lV. INFORMATION SHEET:
        </Text>
        {/* head */}
        <View style={{ marginTop: 10 }}>
          <Text
            style={{
              textAlign: "center",
              backgroundColor: "black",
              color: "white",
              fontSize: 12,
              fontFamily: "Helvetica-Bold",
              paddingVertical: "5px",
            }}
          >
            A: FIRST PARTY - INFORMATION
          </Text>
        </View>
        {/* table 5*/}
        <View style={{ borderBottom: 1, marginTop: 0 }}>
          {/* row 1 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>1</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Name of the Company</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.name}</Text>
            </View>
          </View>
          {/* row 2 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>2</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Address</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.address}</Text>
            </View>
          </View>
          {/* row 3 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>3</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Head Office Location</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.head_office_location}</Text>
            </View>
          </View>
          {/* row 4 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>4</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Company Registration / CR #</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.company_registration}</Text>
            </View>
          </View>
          {/* row 5 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>5</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Ministry of Labor License Number</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.labor_license_number}</Text>
            </View>
          </View>
          {/* row 6 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>6</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Company Sponsor ID (700 series)</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.sponsor_id}</Text>
            </View>
          </View>
          {/* row 7 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>7</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>VAT Number</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{companyDetails?.vat_number}</Text>
            </View>
          </View>
          {/* row 8 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>8</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>
                Authorized Person to sign the contract (name should be mentioned
                in the CR)
              </Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.authorized_person_name}</Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Designation</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.authorized_person_designation}</Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Contact #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.authorized_person_contact}</Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>e-mail #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.authorized_person_email}</Text>
                </View>
              </View>
            </View>
          </View>

          {/* row 9 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>9</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Authorized Project Representative</Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {companyDetails?.authorized_project_representative_name}
                  </Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Designation</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {
                      companyDetails?.authorized_project_representative_designation
                    }
                  </Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Contact #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {companyDetails?.authorized_project_representative_contact}
                  </Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>e-mail #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {companyDetails?.authorized_project_representative_email}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          {/* row 10 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>10</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Authorized Accounts Representative</Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {companyDetails?.authorized_accounts_representative_name}
                  </Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Designation</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {
                      companyDetails?.authorized_accounts_representative_designation
                    }
                  </Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Contact #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {companyDetails?.authorized_accounts_representative_contact}
                  </Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>e-mail #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {companyDetails?.authorized_accounts_representative_email}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          {/* row 11 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>11</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, paddingLeft: 2 }}>
              <Text break>Bank Details for Transactions</Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name of Beneficiary</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.beneficiary_bank}</Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name of Bank</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.bank_name}</Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Branch</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.bank_branch}</Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Type of Account</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.bank_type}</Text>
                </View>
              </View>
              {/* subRow 5 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Account #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.bank_account_number}</Text>
                </View>
              </View>
              {/* subRow 6 */}
              <View
                style={{
                  flexDirection: "row",
                  borderBottom: 1,
                  paddingLeft: 2,
                }}
                break
              >
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>IBAN #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{companyDetails?.bank_iban}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* table 5 copy */}

        <View style={{ marginTop: 10 }}>
          <Text
            style={{
              textAlign: "center",
              backgroundColor: "black",
              color: "white",
              fontSize: 12,
              fontFamily: "Helvetica-Bold",
              paddingVertical: "5px",
            }}
          >
            B: SECOND PARTY - INFORMATION
          </Text>
        </View>
        {/* table 5*/}
        <View style={{ borderBottom: 1, marginTop: 0 }}>
          {/* row 1 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>1</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Name of the Company</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.name}</Text>
            </View>
          </View>
          {/* row 2 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>2</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Address</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.address}</Text>
            </View>
          </View>
          {/* row 3 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>3</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Head Office Location</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.head_office_location}</Text>
            </View>
          </View>
          {/* row 4 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>4</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Company Registration / CR #</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.company_registration}</Text>
            </View>
          </View>
          {/* row 5 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>5</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Ministry of Labor License Number</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.labor_license_number}</Text>
            </View>
          </View>
          {/* row 6 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>6</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Company Sponsor ID (700 series)</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.sponsor_id}</Text>
            </View>
          </View>
          {/* row 7 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>7</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>VAT Number</Text>
            </View>
            <View style={{ width: "60%", padding: 2 }}>
              <Text break>{clientDetails?.vat_number}</Text>
            </View>
          </View>
          {/* row 8 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>8</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>
                Authorized Person to sign the contract (name should be mentioned
                in the CR)
              </Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.authorized_person_name}</Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Designation</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.authorized_person_designation}</Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Contact #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.authorized_person_contact}</Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>e-mail #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.authorized_person_email}</Text>
                </View>
              </View>
            </View>
          </View>
          {/* row 9 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>9</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Authorized Project Representative</Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {clientDetails?.authorized_project_representative_name}
                  </Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Designation</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {
                      clientDetails?.authorized_project_representative_designation
                    }
                  </Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Contact #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {clientDetails?.authorized_project_representative_contact}
                  </Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>e-mail #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {clientDetails?.authorized_project_representative_email}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          {/* row 10 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>10</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, padding: 2 }}>
              <Text break>Authorized Accounts Representative</Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {clientDetails?.authorized_accounts_representative_name}
                  </Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Designation</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {
                      clientDetails?.authorized_accounts_representative_designation
                    }
                  </Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Contact #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {clientDetails?.authorized_accounts_representative_contact}
                  </Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>e-mail #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>
                    {clientDetails?.authorized_accounts_representative_email}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          {/* row 11 */}
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "5%", borderRight: 1, padding: 2 }}>
              <Text break>11</Text>
            </View>
            <View style={{ width: "30%", borderRight: 1, paddingLeft: 2 }}>
              <Text break>Bank Details for Transactions</Text>
            </View>
            <View style={{ width: "65%" }}>
              {/* subRow 1 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name of Beneficiary</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.beneficiary_bank}</Text>
                </View>
              </View>
              {/* subRow 2 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Name of Bank</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.bank_name}</Text>
                </View>
              </View>
              {/* subrow 3 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Branch</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.bank_branch}</Text>
                </View>
              </View>
              {/* subRow 4 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Type of Account</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.bank_type}</Text>
                </View>
              </View>
              {/* subRow 5 */}
              <View style={{ flexDirection: "row", borderBottom: 1 }} break>
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>Account #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.bank_account_number}</Text>
                </View>
              </View>
              {/* subRow 6 */}
              <View
                style={{
                  flexDirection: "row",
                  borderBottom: 1,
                  paddingLeft: 2,
                }}
                break
              >
                <View style={{ width: "25%", borderRight: 1, padding: 2 }}>
                  <Text>IBAN #</Text>
                </View>
                <View style={{ width: "75%", paddingLeft: 2 }}>
                  <Text>{clientDetails?.bank_iban}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* final table */}
        <View break>
          <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 15 }}>
            V. SIGNATURE
          </Text>
          <View
            style={{
              flexDirection: "row",
              padding: 2,
              backgroundColor: "black",
              marginTop: 20,
            }}
          >
            <View style={{ width: "100%" }}>
              <Text
                style={{
                  textAlign: "center",
                  color: "white",
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  paddingVertical: "5px",
                }}
              >
                FIRST PARTY
              </Text>
            </View>
            <View style={{ width: "100%" }}>
              <Text
                style={{
                  textAlign: "center",
                  color: "white",
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  paddingVertical: "5px",
                }}
              >
                SECOND PARTY
              </Text>
            </View>
          </View>
          <View style={{ flexDirection: "row", border: 1, gap: 2 }}>
            <View style={{ width: "100%", padding: 2 }}>
              {firstParty?.map((item, index) => (
                <View key={index} style={{ marginVertical: 10 }}>
                  <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                    {item.title}
                  </Text>
                  <Text>NAME: {item.name}</Text>
                  <Text>DESIGNATION: {item.designation}</Text>
                  <View style={{ height: 65 }}>
                    <Text>SIGNATURE: {item.signature}</Text>
                  </View>
                </View>
              ))}
              <View style={{ height: 65 }}>
                <Text>STAMP:</Text>
              </View>
              <View style={{ height: 65 }}>
                <Text>DATE:</Text>
              </View>
            </View>
            <View style={{ width: "100%", padding: 2 }}>
              {secondParty?.map((item, index) => (
                <View key={index} style={{ marginVertical: 10 }}>
                  <Text style={{ fontSize: 10, fontFamily: "Helvetica-Bold" }}>
                    {item.title}
                  </Text>
                  <Text>NAME: {item.name}</Text>
                  <Text>DESIGNATION: {item.designation}</Text>
                  <View style={{ height: 65 }}>
                    <Text>SIGNATURE: {item.signature}</Text>
                  </View>
                </View>
              ))}
              <View style={{ height: 65 }}>
                <Text>STAMP:</Text>
              </View>
              <View style={{ height: 65 }}>
                <Text>DATE:</Text>
              </View>
            </View>
          </View>
        </View>

        {/* <Image
          style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}
          fixed
          src={
            companyDetails?.footer && companyDetails?.footer != ""
              ? returnSrc(companyDetails?.footer)
              : footerImage
          }
        /> */}
        {/* </Page> */}
      </PageLayout>
    </Document>
  );
}
